var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteProgramm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7132 0.274452C37.7132 0.274452 27.7887 -1.99406 19.5655 6.51282C13.3272 12.7512 11.3423 17.8553 8.79024 24.0937C10.4916 25.7951 12.4765 27.78 14.4614 29.765C20.4161 27.2129 25.5202 24.9444 31.7585 18.706C39.9817 9.91557 37.7132 0.274452 37.7132 0.274452ZM29.7736 13.6019C28.3558 15.0197 26.0873 15.0197 24.3859 13.6019C22.9682 12.1841 22.9682 9.91558 24.3859 8.21421C25.8037 6.7964 28.0723 6.7964 29.7736 8.21421C31.1914 9.63202 31.1914 12.1841 29.7736 13.6019ZM9.64097 15.0197C2.26845 12.7512 0 20.6909 0 20.6909L6.52181 21.8252C7.65604 19.5567 8.50673 17.2882 9.64097 15.0197ZM16.1628 31.7499L17.297 37.9883C17.297 37.9883 25.2366 35.7198 22.9682 28.6307C20.6997 29.765 18.4312 30.8992 16.1628 31.7499ZM9.92454 33.1677C8.50675 34.5855 1.13422 37.1376 1.13422 37.1376C1.13422 37.1376 3.68622 29.4814 5.10402 28.0636C6.52181 26.6458 8.79031 26.6458 9.92454 28.0636C11.3423 29.4814 11.3423 31.7499 9.92454 33.1677Z",
    fill: "#00ADEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteProgramm);
export default __webpack_public_path__ + "static/media/remoteProgramm.5a6f2a40ad80066c3b81ed2247390890.svg";
export { ForwardRef as ReactComponent };